import type { AppUser, ClientOption } from "../../types";
import "./UsersPage.css";

type Props = {
  users: AppUser[];
  clients: ClientOption[];
};

function initials(name: string) {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
}

export default function UsersPage({ users, clients }: Props) {
  const clientName = new Map(clients.map((client) => [client.id, client.name]));

  return (
    <div className="users-page">
      <section className="users-banner">
        <div>
          <p>ADMINISTRATION</p>
          <h2>User Access &amp; Roles</h2>
          <span>
            Review authorised users, client scope and email-alert status.
          </span>
        </div>
      </section>

      <section className="users-panel">
        <div className="user-table user-head">
          <span>User</span>
          <span>Role</span>
          <span>Client access</span>
          <span>Email alerts</span>
          <span>Status</span>
        </div>
        {users.map((user) => (
          <div className="user-table" key={user.userId}>
            <div className="user-cell">
              <div className="mini-avatar">{initials(user.fullName)}</div>
              <div>
                <strong>{user.fullName}</strong>
                <small>{user.email || "No email"}</small>
              </div>
            </div>
            <span className={`role-badge ${user.role.toLowerCase()}`}>
              {user.role}
            </span>
            <span>
              {user.canViewAllClients
                ? "All clients"
                : clientName.get(user.clientId ?? "") || "Not assigned"}
            </span>
            <span className={user.emailAlertsEnabled ? "online" : "inactive"}>
              ● {user.emailAlertsEnabled ? "14 + 7 days" : "Disabled"}
            </span>
            <span className={user.status === "Active" ? "online" : "inactive"}>
              ● {user.status}
            </span>
          </div>
        ))}
        {users.length === 0 && <div className="users-empty">No profiles found.</div>}
      </section>
    </div>
  );
}
